import {
  ONBOARDING_STAFF_URL,
  ONBOARDING_STUDENTS_URL,
} from "../helpers/routes";
import { getMultipartParams, handleResponse } from "../helpers/validate";
import notice from "../../utils/notice";

// TZ-789: two-file roster upload. Each endpoint accepts an xlsx file
// for one school and returns a partial-commit result the UI renders
// into a preview table. Per-row errors come back with row_number so
// the admin can fix in-place and re-upload (the backend is idempotent
// on email/phone so already-imported rows are silently skipped).

const buildFormData = (file, schoolId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("school_id", schoolId);
  return formData;
};

export const uploadStaffRoster = (setterFunction, file, schoolId) =>
  fetch(ONBOARDING_STAFF_URL, getMultipartParams("POST", buildFormData(file, schoolId)))
    .then((res) => handleResponse(res))
    .then((json) => {
      setterFunction(json);
      const created = json && json.summary ? json.summary.created : 0;
      notice(`Staff upload processed (${created} created)`, "success");
      return json;
    })
    .catch((e) => {
      notice("Error uploading staff roster");
      console.error(e.errors || e);
      throw e;
    });

export const uploadStudentRoster = (setterFunction, file, schoolId) =>
  fetch(ONBOARDING_STUDENTS_URL, getMultipartParams("POST", buildFormData(file, schoolId)))
    .then((res) => handleResponse(res))
    .then((json) => {
      setterFunction(json);
      const created = json && json.summary ? json.summary.created : 0;
      notice(`Student upload processed (${created} created)`, "success");
      return json;
    })
    .catch((e) => {
      notice("Error uploading student roster");
      console.error(e.errors || e);
      throw e;
    });
